import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/login'
import Success from '@/view/success'
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        title: '注册兴农达体验版'
      }
    },{
      path: '/Success',
      name: 'Success',
      component: Success,
      meta: {
        title: '注册兴农达体验版'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js